export enum TipoDeAviso {
  Sucesso = 'Sucesso',
  Advertencia = 'Advertência',
  Erro = 'Erro'
}
